/* eslint-disable array-bracket-newline, indent */
import { useEffect, useState } from 'react';
import { StorageKeys } from '../../../helpers/localStorage';

export type wallet = {
  address: string;
  amount: string;
  nativeToken: string;
};

interface IAvailableWallets {
  active: wallet;
  list: wallet[];
}

interface IUseWalletSelectArgs {
  current: wallet;
}

const useWalletSelect = ({ current }: IUseWalletSelectArgs) => {
  const [availableWallets, setAvailableWallets] = useState<IAvailableWallets>({
    active: current,
    list: [],
  });

  useEffect(() => {
    const savedWallets = JSON.parse(
      localStorage.getItem(StorageKeys.available_wallets) || 'null'
    );
    const updatedWalletList = savedWallets
      ? [savedWallets.active, ...savedWallets.list].filter(
          (wallet) => wallet.address !== current.address
        )
      : [];
    const newWallets = {
      active: current,
      list: updatedWalletList,
    };

    setAvailableWallets(newWallets);
    localStorage.setItem(
      StorageKeys.available_wallets,
      JSON.stringify(newWallets)
    );
  }, [current]);

  return availableWallets;
};

export default useWalletSelect;
